/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  is: (key, value) => {
    return `${key.replace(/:is/g, '')} is ${value}`
  },
  is_not: (key, value) => {
    return `${key.replace(/:is_not/g, '')} is_not ${value}`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'date:gte': queryFiltersMappings.gte,
  'date:lte': queryFiltersMappings.lte,
  'latest_exported_on:is': queryFiltersMappings.is,
  'latest_exported_on:is_not': queryFiltersMappings.is_not
}

export default filterMappings